import { CustomButton, SearchBar, searchDateFormat } from "components/form";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CustomModal } from "components/modals/ModalBox";
import Pagination from "react-js-pagination";
import useFullPageLoader from "common/UseFullPageLoader";

import useDebounce from "common/UseDebounce";
import { toastMessage } from "utils/toastMessage";
import NotFound from "common/NotFound";
import { SlRefresh } from "react-icons/sl";
import { DatePicker, Input, Select } from "common/InputForm";
import { toast } from "sonner";
import constant from "../../constants/constatValue";
import { addHelpAnadSupport, helpListApi } from "services/help";
import { dateFormat, formatToDDMMYYYY } from "utils/dateFormat";
import { getSupportListApi } from "services/help";
import { firstWordCapital, getValueOrFallback } from "utils/common";
import findSerialNumber from "utils/findSerialNumber";
import { charLimit } from "utils/formValidator";
import { limitOption, supportFilterValue } from "constants/staticData";
import ReplyHelpSupport from "./replyHelpSupport";

const { SUPPORT_TYPE } = constant;

const HelpAndSupport = () => {
  const [supporTicketList, setSupportTicketList] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [search, setSearch] = useState("");
  const debouncedValue = useDebounce(search, 300);
  const [total, setTotal] = useState(null);
  //   const [buttonLoaderComment, setButtonLoaderComment] = useButtonLoader("Yes");
  const activePage = +searchParams.get("page") || 1;
  const limit = +searchParams.get("limit") || 10;
  const supportTypeValue = searchParams.get("supportType") || "Website Queries";
  const [loader, onShow, onHide] = useFullPageLoader();
  const [descriptionModal, setDescriptionModal] = useState(false);
  const [replyMessageModal, setReplyMessageModal] = useState(false);
  const [selectedTicketData, setSelectedTicketData] = useState({});
  const [message, setMessage] = useState("");
  // change support type handler
  const changeSupportTypeHandler = (type) => {
    searchParams.set("supportType", type);
    searchParams.delete("page");
    setSearchParams(searchParams);
  };

  // handle limit of page
  const handleLimit = (event) => {
    searchParams.set("limit", event.target.value);
    searchParams.delete("page");
    setSearchParams(searchParams);
  };

  // Ticket Reply handler
  const ticketReplyHandler = (data) => {
    setSelectedTicketData(data);
    setReplyMessageModal(true);
  };

  // Message Handler
  const handleMessageHandler = (data) => {
    setDescriptionModal(true);
    setMessage(
      <p
        dangerouslySetInnerHTML={{
          __html: data?.message,
        }}
      ></p>
    );
  };

  //Reset Filter Handler
  const resetFilterHandler = () => {
    searchParams.delete("supportType");
    searchParams.delete("page");
    searchParams.delete("limit");
    setSearch("");
    setSearchParams(searchParams);
  };

  //Handel Pagination
  const handlePageChange = (event) => {
    searchParams.set("page", event);
    setSearchParams(searchParams);
  };

  // Ticket Status Handler
  const supportTicketListHandler = async () => {
    try {
      onShow();
      const reqData = {
        page: activePage,
        limit: limit,
        supportType: supportFilterValue(supportTypeValue),
      };
      if (search && debouncedValue) {
        reqData.search = debouncedValue;
      }
      const { data: responseData, status } = await getSupportListApi(reqData);
      console.log(responseData.total,"responseData")
      if (status === 200) {
        setTotal(responseData?.data?.total);
        setSupportTicketList(responseData?.data?.supportTicketList);
      }
    } catch (e) {
      toast.error(e.message);
    } finally {
      onHide();
    }
  };

  const closeModal = () => {
    setSelectedTicketData({});
    setReplyMessageModal(false);
  };

  // useEffect(() => {
  //   if (Number(activePage) === 1) {
  //     searchParams.delete("page");
  //     setSearchParams(searchParams);
  //   }
  //   supportTicketListHandler();
  // }, [searchParams, debouncedValue, activePage, limit, supportTypeValue]);

  // useEffect(() => {
  //   if (search && debouncedValue) {
  //     searchParams.delete("page");
  //   }
  // }, []);

  return (
    <>
      <div className="student_management">
        <div className="dashboard_title">
          <h3>Help & Support</h3>
        </div>
        <div className="button_section_wrap">
          <div className="search_wrapper">
            <SearchBar
              placeholder={"Search"}
              onChange={(e) => setSearch(e.target.value)}
              value={search}
            />
            <div className="d-flex">
              <CustomButton onClick={resetFilterHandler}>
                <SlRefresh />
              </CustomButton>
            </div>
          </div>
          <div className="button_section">
            <div className="d-flex"></div>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <div className="tab_button_wrap">
              <ul>
                {SUPPORT_TYPE.map((supportType) => (
                  <li key={supportType}>
                    <button
                      type="button"
                      className={
                        supportTypeValue === supportType ? "active" : ""
                      }
                      onClick={() => changeSupportTypeHandler(supportType)}
                    >
                      {firstWordCapital(supportType)}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <div className="table_wrap ">
              <table className="table custom_table">
                <thead>
                  <tr>
                    {(supportFilterValue(supportTypeValue) === "contact" ||
                      supportFilterValue(supportTypeValue) === "help") && (
                      <th className="nowrap text-center">S.No</th>
                    )}
                    {supportFilterValue(supportTypeValue) === "contact" && (
                      <th className="nowrap text-center">email</th>
                    )}
                    {supportFilterValue(supportTypeValue) === "help" && (
                      <>
                        <th className="nowrap text-center">User Name</th>
                        <th className="nowrap text-center">User Type</th>
                        <th className="nowrap text-center">
                          Survey Reference Number
                        </th>
                        <th className="nowrap text-center">Mobile Number</th>
                      </>
                    )}
                    {(supportFilterValue(supportTypeValue) === "contact" ||
                      supportFilterValue(supportTypeValue) === "help") && (
                      <>
                        <th className="nowrap text-center">Reported on</th>
                        <th className="nowrap text-center">Message</th>
                      </>
                    )}
                    {supportFilterValue(supportTypeValue) === "help" && (
                      <th className="nowrap text-center">Action</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {loader}
                  {supporTicketList && supporTicketList?.length > 0 ? (
                    supporTicketList?.map((data, index) => {
                      return (
                        <tr>
                          {(supportFilterValue(supportTypeValue) === "contact" ||
                            supportFilterValue(supportTypeValue) === "help") && (
                            <td className="nowrap text-center">
                              {findSerialNumber(index, activePage, limit)}
                            </td>
                          )}
                          {supportFilterValue(supportTypeValue) === "contact" && (
                            <td className="nowrap text-center">
                              {getValueOrFallback(data?.email)}
                            </td>
                          )}
                          {supportFilterValue(supportTypeValue) === "help" && (
                            <>
                              <td className="nowrap text-center">
                                {getValueOrFallback(data?.name)}
                              </td>
                              <td className="nowrap text-center">
                                {getValueOrFallback(data?.userRole)}
                              </td>
                              <td className="nowrap text-center">
                                {getValueOrFallback(data?.surveyNumber)}
                              </td>
                              <td className="nowrap text-center">
                                {" "}
                                {data?.countryCode +
                                  "-" +
                                  (data?.mobile || "---")}
                              </td>
                            </>
                          )}
                          {(supportFilterValue(supportTypeValue) === "contact" ||
                            supportFilterValue(supportTypeValue) === "help") && (
                            <>
                              <td className="nowrap text-center">
                                {getValueOrFallback(
                                  formatToDDMMYYYY(data?.createdAt)
                                )}
                              </td>

                              <td className="nowrap text-center">
                                {data?.message && data?.message?.length > 30 ? (
                                  <div className="">
                                    <span
                                      dangerouslySetInnerHTML={{
                                        __html: charLimit(data?.message, 30),
                                      }}
                                    ></span>
                                    &nbsp;
                                    <button
                                      type="button"
                                      onClick={() => handleMessageHandler(data)}
                                      className="color-blue"
                                    >
                                      Read More
                                    </button>
                                  </div>
                                ) : (
                                  <p
                                    dangerouslySetInnerHTML={{
                                      __html: data?.message,
                                    }}
                                  ></p>
                                )}
                              </td>
                            </>
                          )}
                          {supportFilterValue(supportTypeValue) === "help" && (
                            <td className="nowrap text-center">
                              {!data?.isReply ? (
                                <CustomButton
                                  onClick={() => ticketReplyHandler(data)}
                                >
                                  Reply
                                </CustomButton>
                              ) : (
                                <CustomButton>Replied</CustomButton>
                              )}
                            </td>
                          )}
                        </tr>
                      );
                    })
                  ) : (
                    <NotFound
                      cols={7}
                      msg={"Support ticket data not found"}
                      onHide={onHide}
                    />
                  )}
                </tbody>
              </table>
            </div>
            <div className="pagination-wrapper">
              <div className="Pagination">
                <select
                  className="input form-control"
                  value={limit}
                  onChange={handleLimit}
                >
                  {limitOption &&
                    limitOption.length > 0 &&
                    limitOption.map((limitValue) => (
                      <option key={limitValue.value} value={limitValue.value}>
                        {limitValue.label}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            {total > limit && (
              <div className="pagination-wrapper">
                <div className="Pagination">
                  <Pagination
                    activePage={activePage}
                    previousLabel={"previous"}
                    nextLabel={"next"}
                    itemsCountPerPage={limit}
                    totalItemsCount={total}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    hideDisabled={true}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {descriptionModal && (
        <CustomModal
          className={"add_model"}
          show={descriptionModal}
          handleClose={() => {
            setDescriptionModal(false);
          }}
        >
          <h3>Message</h3>
          <h7>{message}</h7>
        </CustomModal>
      )}

      {replyMessageModal && (
        <ReplyHelpSupport
          replyModal={replyMessageModal}
          closeModal={closeModal}
          selectedTicketData={selectedTicketData}
          setSupportTicketList={setSupportTicketList}
        />
      )}
    </>
  );
};

export default HelpAndSupport;
